"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
var _goods = require("@/api/marketingFunction/superSubsidyV2/goods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 库存调整表单初始值；打开时按商品行填充
function createStockForm() {
  return {
    id: null,
    adjustType: 1,
    adjustQty: null,
    title: '',
    stockTotal: 0,
    stockRemain: 0
  };
}

/**
 * 超级补贴商品库存调整弹窗（补充/减少，减少不得低于剩余库存）。
 * 商品行由父级列表点击「库存调整」时传入。
 */
var _default = exports.default = {
  name: 'SuperSubsidyV2StockDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 商品列表行：id、title、stockTotal、stockRemain
    row: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    var validateStockQty = function validateStockQty(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入库存调整数量'));
        return;
      }
      if (!Number.isInteger(Number(value)) || Number(value) < 1) {
        callback(new Error('库存调整数量必须为大于0的整数'));
        return;
      }
      if (_this.stockForm.adjustType === 2 && Number(value) > _this.stockForm.stockRemain) {
        callback(new Error('减少的库存数不能大于当前剩余库存数'));
        return;
      }
      callback();
    };
    return {
      stockLoading: false,
      stockForm: createStockForm(),
      stockRules: {
        adjustType: [{
          required: true,
          message: '请选择调整方式',
          trigger: 'change'
        }],
        adjustQty: [{
          validator: validateStockQty,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // el-dialog 需要可写 visible，转成对父级的 .sync 更新
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    // 打开时按商品行初始化表单
    visible: function visible(val) {
      if (!val) return;
      var row = this.row || {};
      this.stockForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, createStockForm()), {}, {
        id: row.id,
        title: row.title,
        stockTotal: row.stockTotal || 0,
        stockRemain: row.stockRemain || 0
      });
    }
  },
  methods: {
    // 校验通过后二次确认再提交
    submitStock: function submitStock(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (!valid) return;
        _this2.$confirm('是否确认进行库存调整?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.onSaveStock();
        }).catch(function () {});
      });
    },
    // 提交调整并通知父级刷新列表
    onSaveStock: function () {
      var _onSaveStock = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.stockLoading) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.stockLoading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _goods.goodsStock)({
                id: this.stockForm.id,
                adjustType: this.stockForm.adjustType,
                adjustQty: Number(this.stockForm.adjustQty)
              });
            case 3:
              this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              this.handleClose();
              this.$emit('saved');
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log(_t);
            case 5:
              _context.p = 5;
              this.stockLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function onSaveStock() {
        return _onSaveStock.apply(this, arguments);
      }
      return onSaveStock;
    }(),
    // 重置调整数量，保留商品行数据
    resetStock: function resetStock(formName) {
      var id = this.stockForm.id;
      var title = this.stockForm.title;
      var stockTotal = this.stockForm.stockTotal;
      var stockRemain = this.stockForm.stockRemain;
      this.stockForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, createStockForm()), {}, {
        id: id,
        title: title,
        stockTotal: stockTotal,
        stockRemain: stockRemain
      });
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
    // 关闭：重置表单并同步父级可见状态
    handleClose: function handleClose() {
      this.resetStock('stockForm');
      this.dialogVisible = false;
    }
  }
};